// Lightweight marketing-cookie consent.
//
// Stores the visitor's choice in localStorage. Marketing pixels
// (src/lib/pixels.ts) stay dormant until consent === 'accept'.
// Essential commerce (cart, checkout) works regardless of the choice.

export type MarketingConsent = 'accept' | 'essential' | null;

const STORAGE_KEY = 'phl_marketing_consent';

// Custom event fired whenever the choice changes so listeners
// (pixel init, banner visibility) react immediately across the app.
export const CONSENT_EVENT = 'phl:consent-changed';

export function getMarketingConsent(): MarketingConsent {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === 'accept' || value === 'essential' ? value : null;
  } catch {
    return null;
  }
}

export function hasMarketingConsent(): boolean {
  return getMarketingConsent() === 'accept';
}

export function setMarketingConsent(choice: Exclude<MarketingConsent, null>) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, choice);
  } catch {
    // Private mode etc. — treat as session-only; pixels simply stay dormant
    // unless 'accept' was set successfully.
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: choice }));
}
